@if (visitorCardAvailable) {
<div fxLayout="row">
  <div fxLayout="column" fxFlex="100%">
    <div fxLayout="row">
      <div class="induction-button-display induction-card-container">
        @if (
          selectedSiteInductionInfo?.inductionId === null ||
          selectedSiteInductionInfo?.inductionId === undefined
        ) {
        <div fxLayout="row" fxFlex="100">
          <div fxLayoutAlign="start center" class="induction-button-img">
            <img class="site-image" [src]="currentSite?.brand?.imageUrl" />
          </div>
          <div
            fxLayout="column"
            class="induction-button-msg"
            fxLayoutAlign="center center"
          >
            <div class="induction-status induction-no-id-message">
              {{ "site_compliance_induction_no_valid_id" | translate }}
            </div>
          </div>
          <div class="induction-button-icon" fxLayoutAlign="center center">
            <mat-icon class="color-city-red">cancel</mat-icon>
          </div>
        </div>
        } @if (
          selectedSiteInductionInfo?.status === SiteInductionStatus.EXPIRED ||
          selectedSiteInductionInfo?.status === SiteInductionStatus.NON_COMPLIANCE
        ) {
        <div fxLayout="row" fxFlex="100">
          <div fxLayoutAlign="start center" class="induction-button-img">
            <img class="site-image" [src]="currentSite?.brand?.imageUrl" />
          </div>
          <div
            fxLayout="column"
            class="induction-button-msg"
            fxLayoutAlign="center center"
          >
            <div class="induction-status">
              {{
                ("site_compliance_lbl_induction_no" | translate).replace(
                  "{induction_no}",
                  selectedSiteInductionInfo?.inductionId
                )
              }}
            </div>
          </div>
          <div
            class="induction-button-icon induction-button-icon-actions"
            fxLayoutAlign="center center"
          >
            <div
              class="induction-status-indicator"
              fxLayout="column"
              fxLayoutAlign="center center"
            >
              <mat-icon class="color-city-red">cancel</mat-icon>
              @if (selectedSiteInductionInfo?.status === SiteInductionStatus.EXPIRED) {
              <span class="color-city-red induction-action-label">{{
                "userprofile_siteinduction_expired" | translate
              }}</span>
              } @else {
              <span class="color-city-red induction-action-label">{{
                "site_compliance_induction_invalid" | translate
              }}</span>
              }
            </div>
          </div>
        </div>
        } @if (selectedSiteInductionInfo?.status === SiteInductionStatus.COMPLIANCE) {
        <div fxLayout="row" fxFlex="100">
          <div fxLayoutAlign="start center" class="induction-button-img">
            <img class="site-image" [src]="currentSite?.brand?.imageUrl" />
          </div>
          <div
            fxLayout="column"
            class="induction-button-msg"
            fxLayoutAlign="center center"
          >
            <div class="induction-status">
              {{
                ("site_compliance_lbl_induction_no" | translate).replace(
                  "{induction_no}",
                  selectedSiteInductionInfo?.inductionId
                )
              }}
            </div>
          </div>
          <div class="induction-button-icon" fxLayoutAlign="center center">
            <mat-icon class="color-city-green">check_circle</mat-icon>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
}
